var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/turnovertype-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-00da843f!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/turnovertype-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/TurnoverTypeList.vue
// module id = 724
// module chunks = 1